import React from 'react';
import TemplatesBasicInfoComponent from './template-groups-basic-info.component';
import { UploadMedia } from '../../../../../common/components/common/upload-media';
import TemplatePlansComponent from './template-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';


export const ProgramComponent = ({ selectedTemplateValues, templates,accountTypesListLoading,accountListLoading, accountsList, accountTypesList, TemplateGroupEntityType, id, onFormItemChange, Account, accountType, PolicyOwnerType, selectedTemplatedGroups, columnDefs, handleEdit, additionButtons, handleDelete, onInnerBasicFormChange, back, handleFormSubmit, communities, Programs }: any) => {

    const handleInnerMediaFormChange: any = ({ field, value }: any) => {
        onFormItemChange({
            value: value.MediaFiles,
            field: 'MediaFiles',
            idx: '', //not used
        });
    };

    const tabItems = [
        {
            id: 1,
            title: 'Basic-Info',
            component: (
                <TemplatesBasicInfoComponent
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedTemplatedGroups={selectedTemplatedGroups}
                    Account={Account}
                    accountType={accountType}
                    PolicyOwnerType={PolicyOwnerType}
                    accountTypesList={accountTypesList}
                    accountTypesListLoading={accountTypesListLoading}
                    accountsList={accountsList}
                    accountListLoading={accountListLoading}
                />
            ),
            isVisible: true,
        },
        // {
        //     id: 2,
        //     title: 'Media',
        //     component:
        //         <UploadMedia
        //             handleInnerFormChange={handleInnerMediaFormChange}
        //             mediaFilesList={selectedTemplatedGroups?.MediaMappings?.MediaFiles}
        //             ownerTypeId={1007}
        //             ownerId={id}
        //             folderName={'event'}
        //         />,
        //     isVisible: true,
        // },
        {
            id: 3,
            title: 'Template Groups',
            component:
                <TemplatePlansComponent
                    handleDelete={handleDelete}
                    additionButtons={additionButtons}
                    TemplateGroupEntityType={TemplateGroupEntityType}
                    handleEdit={handleEdit}
                    templates={templates}
                    columnDefs={columnDefs}
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedTemplateValues={selectedTemplateValues}
                />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default ProgramComponent;
